"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRewarder = exports.RewarderProvider = void 0;
const sail_1 = require("@saberhq/sail");
const token_utils_1 = require("@saberhq/token-utils");
const use_solana_1 = require("@saberhq/use-solana");
const lodash_zip_1 = __importDefault(require("lodash.zip"));
const react_1 = require("react");
const unstated_next_1 = require("unstated-next");
const parsers_1 = require("../parsers");
const useQuarryProgramAddresses_1 = require("../useQuarryProgramAddresses");
const useToken_1 = require("../useToken");
const useGetAllClaimableAmounts_1 = require("./useGetAllClaimableAmounts");
const useRewards_1 = require("./useRewards");
const useRewarderInternal = (args = {}) => {
    const { rewarderKey, minerAuthority } = args;
    if (!rewarderKey) {
        throw new Error("no rewarder key");
    }
    const { publicKey } = (0, use_solana_1.useSolana)();
    const owner = minerAuthority !== null && minerAuthority !== void 0 ? minerAuthority : publicKey;
    const registryInputs = (0, react_1.useMemo)(() => [
        rewarderKey
            ? {
                type: useQuarryProgramAddresses_1.QuarryPDA.QUARRY_REGISTRY,
                path: [rewarderKey],
            }
            : null,
    ], [rewarderKey]);
    const registryKeys = (0, useQuarryProgramAddresses_1.useQuarryProgramAddresses)(registryInputs);
    const { data: registry } = (0, sail_1.useParsedAccountData)(registryKeys[0], parsers_1.PARSE_REGISTRY);
    const { data: rewarder } = (0, sail_1.useParsedAccountData)(rewarderKey, parsers_1.PARSE_REWARDER);
    const rewardToken = (0, useToken_1.useToken)(rewarder === null || rewarder === void 0 ? void 0 : rewarder.accountInfo.data.rewardsTokenMint);
    const stakedTokens = (0, useToken_1.useTokens)(registry === null || registry === void 0 ? void 0 : registry.accountInfo.data.tokens);
    const quarryInputs = (0, react_1.useMemo)(() => {
        var _a, _b;
        return (_b = (_a = registry === null || registry === void 0 ? void 0 : registry.accountInfo.data.tokens) === null || _a === void 0 ? void 0 : _a.map((stakedTokenMint) => {
            return rewarderKey && stakedTokenMint
                ? {
                    type: useQuarryProgramAddresses_1.QuarryPDA.MINE_QUARRY,
                    path: [rewarderKey, stakedTokenMint],
                }
                : null;
        })) !== null && _b !== void 0 ? _b : [];
    }, [registry === null || registry === void 0 ? void 0 : registry.accountInfo.data.tokens, rewarderKey]);
    const quarryKeys = (0, useQuarryProgramAddresses_1.useQuarryProgramAddresses)(quarryInputs);
    const quarriesData = (0, sail_1.useParsedAccountsData)(quarryKeys, parsers_1.PARSE_QUARRY);
    const minerInputs = (0, react_1.useMemo)(() => {
        var _a;
        return (_a = stakedTokens === null || stakedTokens === void 0 ? void 0 : stakedTokens.map((stakedToken) => rewarderKey && stakedToken && owner
            ? {
                type: useQuarryProgramAddresses_1.QuarryPDA.MINE_MINER,
                path: [rewarderKey, stakedToken.mintAccount, owner],
            }
            : null)) !== null && _a !== void 0 ? _a : [];
    }, [owner, rewarderKey, stakedTokens]);
    const minerKeys = (0, useQuarryProgramAddresses_1.useQuarryProgramAddresses)(minerInputs);
    const minersData = (0, sail_1.useParsedAccountsData)(minerKeys, parsers_1.PARSE_MINER);
    const quarries = (0, react_1.useMemo)(() => (0, lodash_zip_1.default)(quarryKeys, stakedTokens !== null && stakedTokens !== void 0 ? stakedTokens : [], quarriesData, minersData)
        .map(([key, token, quarryData, minerData]) => {
        if (!key || !token || !quarryData) {
            return null;
        }
        return {
            key,
            stakedToken: token,
            quarry: quarryData,
            miner: minerData,
        };
    })
        .filter((q) => !!q), [minersData, quarriesData, quarryKeys, stakedTokens]);
    const { getAllClaimableAmounts } = (0, useGetAllClaimableAmounts_1.useGetAllClaimableAmounts)({
        token: rewardToken !== null && rewardToken !== void 0 ? rewardToken : null,
        quarriesData,
        minersData,
    });
    const rewards = (0, useRewards_1.useAllRewards)({ getAllClaimableAmounts });
    const annualRewardsRate = (0, react_1.useMemo)(() => {
        if (!rewardToken || !rewarder) {
            return null;
        }
        return new token_utils_1.TokenAmount(rewardToken, rewarder.accountInfo.data.annualRewardsRate);
    }, [rewardToken, rewarder]);
    const mintWrapper = (0, sail_1.useParsedAccountData)(rewarder === null || rewarder === void 0 ? void 0 : rewarder.accountInfo.data.mintWrapper, parsers_1.PARSE_MINT_WRAPPER);
    const minterInputs = (0, react_1.useMemo)(() => [
        rewarder
            ? {
                type: useQuarryProgramAddresses_1.QuarryPDA.MW_MINTER,
                path: [rewarder.accountInfo.data.mintWrapper, rewarder.accountId],
            }
            : null,
    ], [rewarder]);
    const [minterKey] = (0, useQuarryProgramAddresses_1.useQuarryProgramAddresses)(minterInputs);
    const { data: minterData } = (0, sail_1.useParsedAccountData)(minterKey, parsers_1.PARSE_MINTER);
    return {
        rewarderKey,
        minerAuthority,
        rewarder,
        rewardToken,
        quarries,
        rewards,
        annualRewardsRate,
        mintWrapper: mintWrapper.data,
        minter: minterData,
        registry,
    };
};
_a = (0, unstated_next_1.createContainer)(useRewarderInternal), exports.RewarderProvider = _a.Provider, exports.useRewarder = _a.useContainer;
//# sourceMappingURL=context.js.map